import { useLocation, useNavigate } from 'react-router-dom';
import { FiFileText, FiUserCheck, FiDatabase, FiEdit3, FiHome } from 'react-icons/fi';

const AsthapanDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { grampanchayatName = "ग्रामपंचायत", arthikVarshLabel = "२०२४-२५" } = location.state || {};

  const menuItems = [
    {
      id: 'tax-system',
      title: 'कर प्रणाली',
      icon: <FiDatabase className="w-8 h-8" />,
      description: 'कर आणि रेडीरेकनर व्यवस्थापन',
      path: '/asthapan/tax-system',
      color: 'from-[#267c77] to-teal-600'
    },
    {
      id: 'certificate',
      title: 'दाखला',
      icon: <FiFileText className="w-8 h-8" />,
      description: 'विविध दाखले आणि प्रमाणपत्रे',
      path: '/asthapan/certificates',
      color: 'from-emerald-500 to-teal-500'
    },
    {
      id: 'registration',
      title: 'नोंदणी',
      icon: <FiUserCheck className="w-8 h-8" />,
      description: 'नवीन नोंदणी आणि सुधारणा',
      path: '/asthapan/registrations',
      color: 'from-orange-500 to-amber-500'
    },
    {
      id: 'adhik-dakhle',
      title: 'अधिक दाखले',
      icon: <FiEdit3 className="w-8 h-8" />,
      description: 'इतर महत्वाचे दाखले',
      path: '/asthapan/adhik-dakhle',
      color: 'from-purple-500 to-indigo-500'
    },
    {
      id: 'grampanchayat',
      title: 'ग्रामपंचायत',
      icon: <FiHome className="w-8 h-8" />,
      description: 'ग्रामपंचायत संबंधित माहिती',
      path: '/asthapan/grampanchayat',
      color: 'from-pink-500 to-rose-500'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6 md:p-8">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-[#267c77] text-white">
          <div>
            <h1 className="text-3xl font-bold mb-2">अस्थापना विभाग</h1>
            <p className="text-white/80">
              {grampanchayatName} | आर्थिक वर्ष: {arthikVarshLabel}
            </p>
          </div>
          <button 
            onClick={() => navigate('/grampanchayatnivaad')}
            className="mt-4 md:mt-0 px-6 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors duration-200 text-sm font-medium backdrop-blur-sm"
          >
            मागे जा
          </button>
        </div>
      </div>

      {/* Menu Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {menuItems.map((item) => (
          <div 
            key={item.id}
            onClick={() => item.path !== '#' && navigate(item.path, { state: location.state })}
            className="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden border border-gray-100"
          >
            <div className={`h-2 bg-gradient-to-r ${item.color}`}></div>
            <div className="p-6">
              <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center text-white mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-[#267c77] transition-colors">
                {item.title}
              </h3>
              <p className="text-gray-500 text-sm">
                {item.description}
              </p>
            </div>
            <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-between items-center">
              <span className="text-sm font-medium text-gray-600 group-hover:text-[#267c77] transition-colors">
                निवडा
              </span>
              <svg 
                className="w-5 h-5 text-gray-400 group-hover:text-[#267c77] transform group-hover:translate-x-1 transition-all duration-300" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AsthapanDashboard;
